export { ScrollBar } from './ScrollBar'

import { Plugin } from '@leafer-ui/core'

Plugin.add('scroll')